module.exports = __webpack_public_path__ + "img/18.da0ba076.jpg";